import axiosInstance from "./axios";

export const fetchUserProfile = async (username, token) => {
  try {
    const { data } = await axiosInstance.get(`/profiles/${username}/`, {
      headers: { Authorization: `Token ${token}` },
    });

    return data;
  } catch (err) {
    console.error("Failed to load user profile", err);
    throw err; // rethrow so caller can handle
  }
};

export const fetchUserProfilesBulk = async (usernames) => {
  try {
    const { data } = await axiosInstance.post(`/profiles/bulk/`, {
      usernames: usernames,
    });
    return data;
  } catch (err) {
    console.error("Failed to get users");
  }
};

// Friends
// Get list of the users friends
export const fetchMyFriends = async ({ token, url = `/friends/` }) => {
  try {
    const { data } = await axiosInstance.get(url, {
      headers: { Authorization: `Token ${token}` },
    });

    return data; // { count, next, previous, results }
  } catch (err) {
    console.error("Failed to get users friends");
    throw err;
  }
};

export const unFriend = async (userId) => {
  try {
    const { data } = await axiosInstance.delete(`/friends/${userId}/unfriend/`);
    return data;
  } catch (err) {
    console.log("Failed to delete friendship", err);
    throw err;
  }
};

// Get the status of two users friendship
export const fetchFriendshipStatus = async (username, token) => {
  // return ex. {are_friends: false}
  try {
    const { data } = await axiosInstance.get(`/friends/verify/`, {
      params: { username: username },
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    return data;
  } catch (err) {
    console.error("Failed to get user friendship");
    throw err;
  }
};

// Gets the logged in user's friend requests ( incoming )
export const fetchMyFriendRequests = async (token) => {
  try {
    const { data } = await axiosInstance.get(`/friends/requests/incoming/`, {
      headers: { Authorization: `Token ${token}` },
    });
    return data;
  } catch (err) {
    console.error("Failed to get incoming friend requests");
    throw err;
  }
};

// Get the status of all friend requests ( sent or recieved ) for a given user
export const fetchFriendRequestStatus = async (username, token) => {
  // return ex. []
  try {
    const { data } = await axiosInstance.get(`/friends/requests/status/?to_username=${username}`, {
      headers: { Authorization: `Token ${token}` },
    });

    return data;
  } catch (err) {
    console.error("Failed to get friend reqeust status");
    throw err;
  }
};

export const createFriendRequest = async (userId, token) => {
  try {
    const { data } = await axiosInstance.post(
      `/friends/requests/`,
      { to_user: userId },
      {
        headers: {
          Authorization: `Token ${token}`,
        },
      },
    );
    return data;
  } catch (err) {
    console.error("Failed to create a new friend reqeust");
    throw err;
  }
};

export const acceptFriendRequest = async (requestId, username, token) => {
  try {
    const { data } = await axiosInstance.post(
      `/friends/requests/${requestId}/accept/`,
      {
        params: { username: username },
      },
      {
        headers: { Authorization: `Token ${token}` },
      },
    );
    return data;
  } catch (err) {
    console.error("Failed to accept friend request", err);
    throw err;
  }
};

export const declineFriendRequest = async (requestId, username, token) => {
  try {
    const { data } = await axiosInstance.post(
      `/friends/requests/${requestId}/decline/`,
      {
        params: { username: username },
      },
      {
        headers: { Authorization: `Token ${token}` },
      },
    );
    return data;
  } catch (err) {
    console.error("Failed to decline friend request", err);
    throw err;
  }
};

export const cancelFriendRequest = async (requestId, username, token) => {
  try {
    const { data } = await axiosInstance.post(
      `/friends/requests/${requestId}/cancel/`,
      {
        params: { username: username },
      },
      {
        headers: { Authorization: `Token ${token}` },
      },
    );
    return data;
  } catch (err) {
    console.error("Failed to cancel friend request", err);
    throw err;
  }
};

// Followers

export const toggleFollow = async (username) => {
  try {
    const { data } = await axiosInstance.post(`/profiles/${username}/toggle_follow/`, null);
    return data;
  } catch (err) {
    console.error("Failed to follow/unfollow user", err);
    throw err;
  }
};

export const fetchFollowers = async (username) => {
  try {
    const { data } = await axiosInstance.get(`/api/follows/${username}/followers/`);
    return data;
  } catch (err) {
    console.error("Failed to get list of followers", err);
    throw err;
  }
};

export const fetchFollowing = async (username) => {
  try {
    const { data } = await axiosInstance.get(`/api/follows/${username}/following/`);
    return data;
  } catch (err) {
    console.error("Failed to get list of following", err);
    throw err;
  }
};

// Token invites to sign up for account on app

export const generateInviteLink = async () => {
  try {
    const { data } = await axiosInstance.post(`/invites/`, null);
    return data;
  } catch (err) {
    console.error("Failed to generate invite url", err);
    throw err;
  }
};

export const fetchMyInvites = async () => {
  try {
    const { data } = await axiosInstance.get(`/invites/`);
    return data;
  } catch (err) {
    console.error("Failed to get my invites", err);
    throw err;
  }
};

export const deleteInvite = async (id) => {
  try {
    const { data } = await axiosInstance.delete(`/invites/${id}/`);
    return data;
  } catch (err) {
    console.error("Failed to delete invite", err);
    throw err;
  }
};

export const blockUser = async (userId) => {
  try {
    const res = await axiosInstance.post("/blocks/", { user_id: userId });
    return res.data;
  } catch (err) {
    console.error("Failed to block user", err);
    throw err;
  }
};

export const unblockUser = async (userId) => {
  try {
    const res = await axiosInstance.post("/blocks/unblock/", { user_id: userId });
    return res.data;
  } catch (err) {
    console.error("Failed to unblock user", err);
    throw err;
  }
};

export const fetchBlockedUsers = async () => {
  try {
    const res = await axiosInstance.get("/blocks/");
    return res.data;
  } catch (err) {
    console.error("Failed to fetch blocked users list", err);
    throw err;
  }
};

// Password reset

export const requestPasswordReset = async (email) => {
  try {
    const { data } = await axiosInstance.post("/auth/password/reset/", { email });
    return data;
  } catch (err) {
    console.error("Failed to request password reset", err);
    throw err;
  }
};

export const confirmPasswordReset = async (uid, token, newPassword1, newPassword2) => {
  try {
    const { data } = await axiosInstance.post("/auth/password/reset/confirm/", {
      uid,
      token,
      new_password1: newPassword1,
      new_password2: newPassword2,
    });
    return data;
  } catch (err) {
    console.error("Failed to confirm password reset", err);
    throw err;
  }
};

// @mention autocomplete: GET /profiles/search/?mode=mention&q=<prefix>
// → { results: [BasicProfile] } (id, user_id, username, profile_pic,
// profile_pic_url), at most 8, in the server's order (exact match, friends,
// everyone else). Errors and aborts are the caller's.
export const searchMentionSuggestions = async (query, { signal } = {}) => {
  const { data } = await axiosInstance.get(`/profiles/search/`, {
    params: { mode: "mention", q: query },
    signal,
  });
  return data?.results ?? [];
};
